import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { HighlightButton } from '../Highlights';
import buildTvUrl from '@gameday/utils/buildTvUrl';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import useTracking from '@gameday/utils/hooks/useTracking';
import Link from '@mlb/react-patterns/components/Link/link';
import { useSelector } from 'react-redux';
import { getHighlights } from '../store/selectors/highlightsSelector';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';

const validMediaStates = new Set(['MEDIA_ARCHIVE', 'MEDIA_ON']);
const et = 'America/New_York';

export const HighlightTVList = (props) => {
    const language = useSelector(getLanguage);
    const { mlbTVInfo, deviceInteraction } = useSelector(getHighlights);
    const { tvInfo, date, game_pk: gamePk, tz, gameContext } = mlbTVInfo;
    const translate = useTranslate();
    const Tracking = useTracking();
    const tvArchiveLabel = translate('button_watch_archive', 'Watch Archive');
    const defaultText = gameContext ? gameContext?.toUpperCase() + '.TV' : 'MLB.TV';
    const defaultKey = gameContext ? gameContext + 'tv' : 'mlbtv';
    const tvWatchLabel = translate(defaultKey, defaultText);
    const mediaStateLabelMap = {
        MEDIA_ARCHIVE: tvArchiveLabel,
        MEDIA_ON: tvWatchLabel
    };
    const UTCDate = zonedTimeToUtc(date, tz);
    const formattedDate = format(utcToZonedTime(UTCDate, et), 'yyyyMMdd');
    const trackHighlight = useCallback((trackData) => {
        const cfg = {
            componentName: ['Wrap', 'Highlights'],
            text: trackData || '',
            activity: `${trackData} Click`
        };
        Tracking.track.track_click(cfg);
    }, [Tracking]);

    const tvURL = buildTvUrl({ gamePk, date }, tz, gameContext, language);
    const tvMediaStates = new Set([]);
    const handleTvClick = useCallback((e) => {
        trackHighlight(e?.currentTarget?.innerText);
        if (deviceInteraction?.tvapp({ gamePk, date: formattedDate })) {
            e.preventDefault();
        }
    }, [trackHighlight, mlbTVInfo]);

    const tvList = useMemo(() => {
        return tvInfo?.map((item) => {
            if (validMediaStates.has(item.mediaState) && !tvMediaStates.has(item?.mediaState)) {
                tvMediaStates.add(item.mediaState);
                return (
                    <Link
                        key={item.mediaState}
                        url={tvURL}
                        handlers={{ onClick: handleTvClick }}
                        target={'_blank'}
                    >
                        <HighlightButton>{mediaStateLabelMap[item.mediaState]}</HighlightButton>
                    </Link>
                );
            }
        });
    }, [mlbTVInfo, props.isMobile]);
    return (
        <>
            {tvList}
        </>
    );
};

HighlightTVList.propTypes = {
    isMobile: PropTypes.bool
};
